<script lang="ts">
    import { Col } from "sveltestrap";
    import { ActivityTimeline, YearlyUser } from "../../../utils/Constant/Constant";
    import Card from "../../Core/Card.svelte";
    import ActivityTimelineMedia1 from "./ActivityTimelineMedia1.svelte";
    import ActivityTimelineMedia2 from "./ActivityTimelineMedia2.svelte";
    import ActivityTimelineMedia3 from "./ActivityTimelineMedia3.svelte";
    import ActivityTimelineMedia4 from "./ActivityTimelineMedia4.svelte";
    import ActivityTimelineMedia5 from "./ActivityTimelineMedia5.svelte";
    import ActivityTimelineMedia6 from "./ActivityTimelineMedia6.svelte";
</script>

<Col xl="4" class="des-xl-50 box-col-12 activity-sec chart_data_left">
    <Card>
    <div class="header-top d-sm-flex justify-content-between align-items-center" slot="customheader">
        <h5 class="m-0">{ActivityTimeline}</h5>
        <div class="center-content">
        <p >{YearlyUser} 24.65k</p>
        </div>
        </div>
        <div slot="contentbody">
            <div class="chart-main activity-timeline update-line">
                <ActivityTimelineMedia1 />
                <ActivityTimelineMedia2 />
                <ActivityTimelineMedia3 />
                <ActivityTimelineMedia4 />
                <ActivityTimelineMedia5 />
                <ActivityTimelineMedia6 />
            </div>
        </div>
    </Card>
</Col>
